<template>
  <div class="map" id="map">
    <div class="part1" id="p1">
      <img :src="img1" v-if="img1" />
    </div>
    <div class="part2" id="p2">
      <img :src="img2" v-if="img2" />
    </div>
  </div>
</template>

<script>
import p1Blue from '@/assets/images/part_1_blue.png'
import p1Green from '@/assets/images/part_1_green.png'
import p1Red from '@/assets/images/part_1_red.png'

import p2Blue from '@/assets/images/part_2_blue.png'
import p2Green from '@/assets/images/part_2_green.png'
import p2Red from '@/assets/images/part_2_red.png'

export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },

  watch: {
    data: {
      deep: true,
      immediate: true,
      handler: function (v) {
        if (v && v.length) {
          // 找出土壤水势传感器
          const list = v
            .map((o) => {
              if (o.isWater) return o
            })
            .filter((o) => o)
            .sort((a, b) => a.channelNo - b.channelNo)

          if (list && list.length) {
            const wList = [list[0], list[list.length - 1]]
            console.log('wList:', wList)
            wList.map((o, i) => {
              // 超过上限 饱和 蓝色
              console.log(o.lowerLimit, Number(o.value), o.uperLimit)
              if (Number(o.value) > o.uperLimit) {
                this[`img${i + 1}`] = this[`p${i + 1}Red`]
              } else if (Number(o.value) < o.lowerLimit) {
                // 低过下限 缺水 红色
                this[`img${i + 1}`] = this[`p${i + 1}Blue`]
              } else {
                // 正常 绿色
                this[`img${i + 1}`] = this[`p${i + 1}Green`]
              }
            })

            console.log('this.img1: ', this.img1)
            console.log('this.img2:', this.img2)
          } else {
            this.img1 = ''
            this.img2 = ''
          }
        } else {
          this.img1 = ''
          this.img2 = ''
        }
      },
    },
  },

  created() {
    ;[1000000289, 1000000287].map(async (no, i) => {
      const list = await this.getCgqList(no)
      let blue = 0
      let green = 0
      let red = 0
      list.map((o) => {
        if (Number(o.value) > o.uperLimit) {
          red++
        } else if (Number(o.value) < o.lowerLimit) {
          blue++
        } else {
          green++
        }
      })

      if (red === 3) {
        this[`img${i + 1}`] = this[`p${i + 1}Red`]
      } else if (blue >= 2) {
        this[`img${i + 1}`] = this[`p${i + 1}Blue`]
      } else {
        this[`img${i + 1}`] = this[`p${i + 1}Green`]
      }
    })
  },

  mounted() {
    // 获取map的
    // const map = document.getElementById('map')
    // const p1 = document.getElementById('p1')
    // const p2 = document.getElementById('p2')
    // const mW = map.offsetWidth
    // const mH = map.offsetHeight
    // const p1T = (72 / 255) * mH
    // const p1R = (110 / 396) * mW
    // const p2T = (82 / 255) * mH
    // const p2R = (52 / 396) * mW
    // p1.style.top = p1T + 'px'
    // p1.style.right = p1R + 'px'
    // p2.style.top = p2T + 'px'
    // p2.style.right = p2R + 'px'
  },

  data() {
    return {
      p1Blue,
      p1Green,
      p1Red,
      p2Blue,
      p2Green,
      p2Red,
      img1: p1Blue,
      img2: p2Blue,
    }
  },

  methods: {
    async getCgqList(no) {
      await this.$toast.loading({
        message: this.$t('common.loading'),
        forbidClick: true,
        duration: 0,
      })

      return await this.$api
        .getLiveList({
          no,
          limit: 1,
          startDate: '2020-01-01 00:00:00',
          endDate: this.$setime(new Date(), 1),
        })
        .then((res) => {
          if (res.errcode === 0) {
            if (!this.$isblank(res.list)) {
              const list = res.list
              const relist = [...list[0].data]
                .map((item, index) => {
                  return {
                    isWater: item.oriName === '土壤张力',
                    sort: item.oriName === '土壤张力' ? 888 + index : index,
                    ...item,
                    showPopover: false,
                  }
                })
                .sort((a, b) => a.sort - b.sort)

              const _list = relist
                .map((o) => {
                  if (o.isWater) return o
                })
                .filter((o) => o)
                .sort((a, b) => a.channelNo - b.channelNo)

              return _list
            } else {
              return []
            }
          } else {
            // 其他异常
            this.$toast(res.errmsg)
            return []
          }
        })
        .catch((err) => {
          this.$toast(this.$t('common.timeout'))
          return []
        })
        .finally(() => {
          this.$toast.clear()
        })
    },
  },
}
</script>

<style scoped lang="scss">
.map {
  position: relative;
  background: url('../../../assets/images/map.jpg') no-repeat;
  background-size: cover;
  width: calc(100% + 6px);
  height: 255px;
  margin-left: -6px;
}

.part1,
.part2 {
  position: absolute;
}

.part1 {
  top: 1.44rem;
  right: 2.2rem;
}

.part2 {
  // top: 1.64rem;
  // right: 1.08rem;
  top: 1.6rem;
  right: 0.98rem;
}
</style>
